module.exports = __webpack_public_path__ + "static/GrayGminaMielno-063f0ddd2e6133ad44088342c25db3fa.svg";